import { drawAnnotations, type PhotoAnnotation } from '../domain/annotation';

// The report's copy of an annotated photo (Owner decision list 2026-10-19 item 22): the print-size image
// with the inspector's arrows / circles / boxes drawn on it. The stored photo is never changed. Where no
// canvas is available the photo prints without its marks rather than not at all.
function loadImage(src: string, timeoutMs: number): Promise<HTMLImageElement | null> {
  return new Promise((resolve) => {
    const img = new Image();
    const timer = setTimeout(() => resolve(null), timeoutMs);
    img.onload = () => {
      clearTimeout(timer);
      resolve(img);
    };
    img.onerror = () => {
      clearTimeout(timer);
      resolve(null);
    };
    img.src = src;
  });
}

export async function markedPhotoDataUrl(dataUrl: string | null, annotations: readonly PhotoAnnotation[] | undefined): Promise<string | null> {
  if (!dataUrl || !annotations || annotations.length === 0 || typeof document === 'undefined') return dataUrl;
  try {
    const canvas = document.createElement('canvas');
    const ctx = typeof canvas.getContext === 'function' ? canvas.getContext('2d') : null;
    if (!ctx) return dataUrl;
    const img = await loadImage(dataUrl, 5_000);
    if (!img || img.naturalWidth === 0 || img.naturalHeight === 0) return dataUrl;
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    ctx.drawImage(img, 0, 0);
    drawAnnotations(ctx, annotations, canvas.width, canvas.height);
    return canvas.toDataURL('image/jpeg', 0.85);
  } catch {
    return dataUrl;
  }
}
